import { RemoteGroupList } from 'data/usecases';
import { GetGroupListUseCaseInterface } from 'domain/usecases';
import { makeApiUrlGroupList } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetGroupList = (): GetGroupListUseCaseInterface =>
  new RemoteGroupList(makeApiUrlGroupList(), makeAxiosHttpClient());
